
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { RegionType, RegionPayloadType } from "@/common/types/region";

export async function regionList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/region/list${queryString}`
    );
}

export async function regionGet(
    region_id: string
) {
    return await clientAxios.get(
        `admin/region/${region_id}/show`
    );
}

export async function regionAdd(
    payload: RegionPayloadType
) {
    return await clientAxios.post(
        `admin/region/create`,
        payload
    );
}

export async function regionPatch(
    region_id: string,
    payload: Partial<RegionType>
) {
    return await clientAxios.patch(
        `admin/region/${region_id}/patch`,
        { payload }
    );
}

export async function regionDel(
    region_id: string,
) {
    return await clientAxios.del(
        `admin/region/${region_id}/delete`,
    );
}
